<template>
  <div>
    <UiCard class="settings_wrapper">
      <div slot="title">
        <div class="title">Список транзакций </div>
      </div>

      <div slot="content">
        <TextSearchInput v-model="comment" />

        <UiTable
          :storage-id="storageId"
          :source-columns="columns"
          :rows="rows"
          :is-loading="isLoading"
          :pagination="{ 'page-index': page, 'page-size': pageSize }"
          :total="total"
          :sort-props="{ multipleSort: false, sortAlways: false }"
          v-on="paginationListeners"
        />
      </div>
    </UiCard>
  </div>
</template>

<script>
import UiTable from '@/components/table/UiTable.vue'
import UiCard from '@/components/card/UiCard.vue'
import tableDefaults from '@/components/table/tableDefaults'

import columns from './columns'
import TextSearchInput from './TextSearchInput.vue'

import { TransactionsService } from '@/services/transactions.service'

import { CURRENT_YEAR, CURRENT_MONTH } from '@/config/date'

import syncQuery from '@/mixins/syncUrlQuery'

export default {
  components: { UiTable, UiCard, TextSearchInput },
  mixins: [syncQuery, columns, tableDefaults],
  data() {
    return {
      comment: '',
      storageId: 'transactions-table',
      paginationUpdateLocaly: true,
    }
  },
  computed: {
    fetchParams() {
      return {
        comment: this.comment,
        page: this.page,
        sort: this.sort,
        year: this.$route.query.year ?? CURRENT_YEAR,
        month: this.$route.query.month ?? CURRENT_MONTH,
        pageSize: this.pageSize,
        appId: this.$route.params.id,
      }
    },
  },
  watch: {
    fetchParams: {
      handler: 'getTransactionsList',
      immediate: true,
    },
    comment: {
      handler: function () {
        this.page = 1
      },
    },
  },
  methods: {
    async getTransactionsList() {
      this.isLoading = true

      try {
        const { data } = await TransactionsService.getList(this.colletQueryParams(this.fetchParams))

        this.rows = data.content
        this.total = data.total
      } catch (e) {
        this.$store.commit('toast/NEW', { type: 'error', message: e.message, e })
        this.error = e.message
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
